<template>
  <section
    class="vfusSlides"
    :data-background-image="gifUrl"
    :data-background-size="backgroundSize"
    data-background-opacity="0.2"
  >
    <section v-for="(vfus, index) in vfuSlides" :key="'vfugroup' + index">
      <div
        class="sl-block"
        data-block-type="text"
        style="left: 29px; top: 84px; height: auto"
      >
        <div
          class="sl-block-content"
          data-placeholder-tag="h2"
          data-placeholder-text="Title Text"
          style="text-align: left; z-index: 10"
          dir="ui"
        >
          <h2 style="text-align: center">Systems Status</h2>
        </div>
      </div>

      <div
        class="sl-block"
        data-block-type="table"
        style="
          height: auto;
          min-width: 120px;
          width: 100%;
          left: 29px;
          top: 175.5px;
        "
      >
        <table>
          <tbody>
            <tr v-for="vfu in vfus" :key="'vfu' + vfu.platformGroupName">
              <td style="white-space: nowrap">{{ vfu.platformGroupName }}</td>
              <td style="white-space: nowrap">
                <light-intensity
                  :lightState="vfu.lightState"
                  :lightIntensityAverage="vfu.lightIntensityAverage"
                  v-if="vfu.lightState"
                />

                <curtain-state
                  v-model="vfu.curtainState"
                  v-if="vfu.curtainState"
                />

                <irrigation-state
                  v-if="vfu.irrigationState"
                  v-model="vfu.irrigationState"
                />

                <co2-state
                  :facility_co2Enabled="facility.co2Enabled"
                  :co2Enabled="vfu.co2Enabled"
                  v-model="vfu.co2ValveState"
                />

                <ecu-state v-if="vfu.ECUState" v-model="vfu.ECUState" />
                <ecu-state v-if="vfu.BardState" v-model="vfu.BardState" />

                <heaterstrip-state v-model="vfu.heaterstripState" />

                <span v-if="vfu.vfuHumidifierState">
                  <humidifier-state v-model="vfu.vfuHumidifierState" />
                </span>

                <span v-if="vfu.vfuDehumidifierState">
                  <dehumidifier-state v-model="vfu.vfuDehumidifierState" />
                </span>

                <span v-if="vfu.vfu2StageDehumidifierState">
                  <dehumidifier2-state
                    v-model="vfu.vfu2StageDehumidifierState"
                  />
                </span>

                <mode-of-operation v-model="vfu.mode" />
              </td>

              <td>
                <template v-if="!vfu.lifecycles">
                  <v-icon color="silver">local_florist</v-icon>
                </template>
                <template v-else>
                  <v-icon v-if="!vfu.pestDetected" color="green"
                    >local_florist</v-icon
                  >
                  <v-icon v-else color="red">local_florist</v-icon>
                </template>
              </td>

              <td>
                <span
                  class="highlightfield"
                  v-bind:class="{
                    highvalue: vfu.tempHigh,
                    lowvalue: vfu.tempLow,
                    oldvalue: getMetricStyle(vfu.lastTempUpdate),
                  }"
                  v-show="vfu.temperature > 0"
                  >{{ vfu.temperatureFormatted }}</span
                >
              </td>

              <td>
                <span
                  class="highlightfield"
                  v-bind:class="{
                    highvalue: vfu.humidityHigh,
                    lowvalue: vfu.humidityLow,
                    oldvalue: getMetricStyle(vfu.lastHumidityUpdate),
                  }"
                  v-show="vfu.humidity > 0"
                  >{{ parseFloat(vfu.humidity * 100).toFixed(0) }} %</span
                >
              </td>

              <td>
                <span
                  class="highlightfield"
                  v-bind:class="{
                    highvalue: vfu.co2High,
                    lowvalue: vfu.co2Low,
                    oldvalue: getMetricStyle(vfu.lastCo2Update),
                  }"
                  v-show="vfu.co2 > 0"
                  >{{ vfu.co2 }} ppm</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import PlatformContainerHelpers from "@/mixins/PlatformContainerHelpers";
import BaseMixin from "@/mixins/base.js";
import lightIntensity from "@/components/zoneDevices/widgets/LightIntensity.vue";
import CurtainState from "@/components/zoneDevices/widgets/CurtainState.vue";
import IrrigationState from "@/components/zoneDevices/widgets/IrrigationState.vue";
import Co2State from "@/components/zoneDevices/widgets/Co2State.vue";
import ModeOfOperation from "@/components/zoneDevices/widgets/ModeOfOperation.vue";
import EcuState from "@/components/zoneDevices/widgets/EcuState.vue";
import HeaterstripState from "@/components/zoneDevices/widgets/HeaterstripState.vue";
import HumidifierState from "@/components/zoneDevices/widgets/HumidifierState.vue";
import DehumidifierState from "@/components/zoneDevices/widgets/DehumidifierState.vue";
import Dehumidifier2State from "@/components/zoneDevices/widgets/Dehumidifier2State.vue";

export default {
  name: "",
  props: [],
  mixins: [BaseMixin, PlatformContainerHelpers],
  components: {
    lightIntensity,
    CurtainState,
    IrrigationState,
    Co2State,
    EcuState,
    ModeOfOperation,
    HeaterstripState,
    HumidifierState,
    DehumidifierState,
    Dehumidifier2State,
  },
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/AGR-VFU.gif";
      this.backgroundSize = "cover";
    } else {
      this.gifUrl = "/img/presentationbackgrounds/AGR-VFU.gif";
      this.backgroundSize = "50%";
    }

    this.refresh();
  },
  mounted() {},
  data() {
    return {
      vfuSlides: [],
      facility: {},
      gifUrl: null,
      videoUrl: null,
      backgroundSize: "initial",
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;

      Trimaster.get(
        "facilities/" + this.getUser.facility_id,
        this.getUser.apitoken
      ).then(function ([res, err]) {
        me.facility = res;
      });

      Trimaster.get("ag_platformGroups/getFullStatus", this.getUser.apitoken, {
        facility_id: me.getUser.facility_id,
      }).then(function ([results, err]) {
        // divide into slides with 5 recs each
        let out = [];
        let j = 0;
        for (let i = 0; i < results.length; i++) {
          if (i % 7 == 0) {
            out.push([]);
            j++;
          }
          out[out.length - 1].push(me.createDisplayRecord(results[i], "VFU"));
        }
        me.vfuSlides = out;
      });
    },
  },
};
</script>
<style lang="scss">
.vfusSlides {
  td {
    font-size: 0.9em;
  }
  .highlightfield {
    white-space: nowrap;
    width: 100%;
    height: 100%;
    display: block;
    padding-top: 6px;
  }
  .highvalue {
    color: red;
    font-weight: bold;
  }
  .lowvalue {
    font-weight: bold;
    color: lightskyblue;
  }
  .oldvalue {
    color: silver;
    font-style: italic;
  }
}
</style>

